import { render, staticRenderFns } from "./UserDetailsDeleteUserModal.vue?vue&type=template&id=c1174930"
import script from "./UserDetailsDeleteUserModal.vue.ts?vue&type=script&lang=ts&external"
export * from "./UserDetailsDeleteUserModal.vue.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports